import * as React from "react";

function SvgCrown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 267.5 267.5"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M256.975 100.34a7.48 7.48 0 01-.198 2.229l-16.5 66a7.503 7.503 0 01-7.238 5.681l-99 .5H35a7.5 7.5 0 01-7.277-5.688l-16.5-66.25a7.488 7.488 0 01-.197-2.289C4.643 98.512 0 92.539 0 85.5c0-8.685 7.065-15.75 15.75-15.75S31.5 76.815 31.5 85.5c0 4.891-2.241 9.267-5.75 12.158l20.658 20.814c5.221 5.261 12.466 8.277 19.878 8.277 8.764 0 17.12-4.162 22.382-11.135l33.95-44.984A15.694 15.694 0 01118 59.5c0-8.685 7.065-15.75 15.75-15.75s15.75 7.065 15.75 15.75c0 4.212-1.672 8.035-4.375 10.864.009.012.02.022.029.035l33.704 45.108c5.26 7.04 13.646 11.243 22.435 11.243 7.48 0 14.514-2.913 19.803-8.203l20.788-20.788C238.301 94.869 236 90.451 236 85.5c0-8.685 7.065-15.75 15.75-15.75s15.75 7.065 15.75 15.75c0 6.851-4.405 12.678-10.525 14.84zm-18.308 97.91a7.5 7.5 0 00-7.5-7.5h-194a7.5 7.5 0 00-7.5 7.5v18a7.5 7.5 0 007.5 7.5h194a7.5 7.5 0 007.5-7.5v-18z" />
    </svg>
  );
}

export default SvgCrown;
